import React from 'react';
import { HighlightTextField } from './HighlightTextField.styles';

interface NameFieldProps {
  value: string;
  onChange: (value: string) => void;
  isSelected: boolean;
  onClick: () => void;
  error?: boolean;
  helperText?: string;
}

export const NameField: React.FC<NameFieldProps> = ({ 
  value, 
  onChange, 
  isSelected, 
  onClick,
  error = false,
  helperText = '',
}) => {
  return (
    <HighlightTextField
      highlighted={isSelected}
      label="Campaign Name"
      value={value}
      onChange={e => onChange(e.target.value)}
      onClick={onClick}
      variant="outlined"
      fullWidth
      required
      error={error}
      helperText={helperText}
    />
  );
};
